const FR = {
  'eclipse.interior.image-1.hotspot-1.label': 'Volant et tableau de bord',
  'eclipse.interior.image-1.hotspot-1.message': 'Volant et tableau de bord',
  'eclipse.interior.image-1.hotspot-2.label': 'Climatisation',
  'eclipse.interior.image-1.hotspot-2.message': 'Climatisation',
  'eclipse.interior.image-1.hotspot-3.label': 'Levier de vitesses et console centrale',
  'eclipse.interior.image-1.hotspot-3.message': 'Levier de vitesses et console centrale',
  'eclipse.interior.image-1.hotspot-4.label': 'Siège du conducteur',
  'eclipse.interior.image-1.hotspot-4.message': 'Siège du conducteur',
  'eclipse.interior.image-1.hotspot-5.label': 'Connectivité et infodivertissement',
  'eclipse.interior.image-1.hotspot-5.message': 'Connectivité et infodivertissement',

  'eclipse.interior.image-2.hotspot-1.label': 'Commodités de la 2e rangée',
  'eclipse.interior.image-2.hotspot-1.message': 'Commodités de la 2e rangée',
  'eclipse.interior.image-2.hotspot-2.label': 'Sièges garnis de cuir',
  'eclipse.interior.image-2.hotspot-2.message': 'Sièges garnis de cuir',
  'eclipse.interior.image-2.hotspot-3.label': 'Caractéristiques de sécurité active',
  'eclipse.interior.image-2.hotspot-3.message': 'Caractéristiques de sécurité active',
  'eclipse.interior.image-2.hotspot-4.label': 'Ceintures et systèmes de retenue',
  'eclipse.interior.image-2.hotspot-4.message': 'Ceintures et systèmes de retenue',

  'eclipse.exterior.hotspot-1.label': 'Moteur et transmission',
  'eclipse.exterior.hotspot-1.message': 'Moteur et transmission',
  'eclipse.exterior.hotspot-2.label': 'Super contrôle intégral',
  'eclipse.exterior.hotspot-2.message': 'Super contrôle intégral',
  'eclipse.exterior.hotspot-3.label': 'Roues et pneus',
  'eclipse.exterior.hotspot-3.message': 'Roues et pneus',
  'eclipse.exterior.hotspot-4.label': 'Hayon et bouchon de carburant',
  'eclipse.exterior.hotspot-4.message': 'Hayon et bouchon de carburant',
  'eclipse.exterior.hotspot-5.label': 'Caractéristiques de sécurité active',
  'eclipse.exterior.hotspot-5.message': 'Caractéristiques de sécurité active',

  'eclipse.blueprint.safety.tab-1': 'Coussins gonflables latéraux en rideau',
  'eclipse.blueprint.safety.tab-2': 'Coussin gonflable pour genoux du conducteur',
  'eclipse.blueprint.safety.tab-3': 'Coussins gonflables frontaux doubles',
  'eclipse.blueprint.safety.tab-4': 'Coussins gonflables latéraux montés aux sièges avant',
  'eclipse.blueprint.safety.hotspot-1.label': 'Coussins latéraux en rideau (1re et 2e rangée)',
  'eclipse.blueprint.safety.hotspot-1.message': 'Coussins latéraux en rideau (1re et 2e rangée)',
  'eclipse.blueprint.safety.hotspot-2.label': 'Coussin pour genoux du conducteur',
  'eclipse.blueprint.safety.hotspot-2.message': 'Coussin pour genoux du conducteur',
  'eclipse.blueprint.safety.hotspot-3.label': 'Coussins frontaux doubles',
  'eclipse.blueprint.safety.hotspot-3.message': 'Coussins frontaux doubles',
  'eclipse.blueprint.safety.hotspot-4.label': 'Coussins latéraux montés aux sièges avant',
  'eclipse.blueprint.safety.hotspot-4.message': 'Coussins latéraux montés aux sièges avant',

  'eclipse-cross.launcher.introduction': "Cliquez pour poser des questions sur l'Eclipse Cross",
}

export default FR
